module.exports = __webpack_public_path__ + "fonts/CaviarDreams_Bold.65ab651c.ttf";